module.exports = __webpack_public_path__ + "static/images/smart-spot-shield-outline.f01e1db63f294170d3ec9b8ccdb9db01.svg";